module.exports = __webpack_public_path__ + "static/media/apps.23178009.jpg";